import React from 'react';
import { createUseStyles } from "react-jss";

import { ReactComponent as TopInstruments1 } from '../../../img/top-instruments-2.svg';
import { ReactComponent as TopInstruments2 } from '../../../img/top-instruments-1.svg';
import { ReactComponent as ATNEditor } from '../../../img/ATN-Editor.svg';
import { ReactComponent as TopInstrumentsCanvas } from '../../../img/top-instruments3.svg';
import { ReactComponent as ATNEditorTools } from '../../../img/ATN-Editor-tools.svg';
import { ReactComponent as TopInstrumentsUndoRedo } from '../../../img/top-instruments-undo-redo.svg';
import { ReactComponent as TopInstrumentsShare } from '../../../img/top-instruments-share.svg';
import zoom from '../../../img/zoom.png';

const useStales = createUseStyles({
    infoImg: {
        height: 350,
        textAlign: 'center',
    },

})

const QuestionContent = ({ page }) => {
    const classes = useStales();

    return (
        <>
            <div className={classes.infoBlock}>

                {page === 0 && (
                    <>
                        <div className={classes.infoImg}>
                            <ATNEditor />
                        </div>

                        <div className={classes.infoText}>
                            <h1 style={{ marginTop: 0, fontSize: 20 }}>1. Libraries</h1>
                            <p style={{ margin: 0, color: '#AAAAAA' }}>All your saved reticles in one place. You’ll also find reticles created by other users here. Easily reuse, edit, or share them.</p>
                        </div>
                    </>
                )}

                {page === 1 && (
                    <>
                        <div className={classes.infoImg}>
                            <TopInstruments1 />
                            <TopInstruments2 />
                        </div>

                        <div className={classes.infoText}>
                            <h1 style={{ marginTop: 0, fontSize: 20 }}>2. Reticle Name</h1>
                            <p style={{ margin: 0, color: '#AAAAAA' }}>Name your reticle to keep your designs organized and easy to find later.</p>
                        </div>
                    </>
                )}

                {page === 2 && (
                    <>
                        <div className={classes.infoImg}>
                            <TopInstrumentsCanvas />
                        </div>

                        <div className={classes.infoText}>
                            <h1 style={{ marginTop: 0, fontSize: 20 }}>3. Canvas Grid Size</h1>
                            <p style={{ margin: 0, color: '#AAAAAA' }}>Set the size of the drawing grid to define your work area. A larger grid gives you more space for detail.</p>
                        </div>
                    </>
                )}

                {page === 3 && (
                    <>
                        <div className={classes.infoImg}>
                            <ATNEditorTools />
                        </div>

                        <div className={classes.infoText}>
                            <h1 style={{ marginTop: 0, fontSize: 20 }}>4. Tools</h1>
                            <p style={{ margin: 0, color: '#AAAAAA' }}>Choose from a set of drawing tools:</p>
                            <ul>
                                <li>Line, Circle, Rectangle, Triangle, Square</li>
                                <li>Roman and Arabic Numbers</li>
                                <li>Hand Tool – move the canvas</li>
                                <li>Arrow Tool – select and move shapes on the canvas</li>
                            </ul>
                        </div>
                    </>
                )}

                {page === 4 && (
                    <>
                        <div className={classes.infoImg}>
                            <img src={zoom} alt="Zoom" style={{ width: 600, height: 350 }} />
                        </div>

                        <div className={classes.infoText}>
                            <h1 style={{ marginTop: 0, fontSize: 20 }}>5. Zoom</h1>
                            <p style={{ margin: 0, color: '#AAAAAA' }}>Zoom in or out of the canvas to make precise edits or view the full reticle.</p>
                        </div>
                    </>
                )}

                {page === 5 && (
                    <>
                        <div className={classes.infoImg}>
                            <TopInstrumentsUndoRedo />
                        </div>

                        <div className={classes.infoText}>
                            <h1 style={{ marginTop: 0, fontSize: 20 }}>6. Edit Tools</h1>
                            <ul>
                                <li>Duplicate – Copy selected elements</li>
                                <li>Undo / Redo – Step back or forward through your actions</li>
                                <li>Delete – Remove selected elements</li>
                                <li>Clear All – Erase everything and start fresh</li>
                            </ul>
                        </div>
                    </>
                )}

                {page === 6 && (
                    <>
                        <div className={classes.infoImg}>
                            <TopInstrumentsShare />
                        </div>

                        <div className={classes.infoText}>
                            <h1 style={{ marginTop: 0, fontSize: 20 }}>7. Preview / Share / Download</h1>
                            <ul>
                                <li>Preview – See how your reticle will look through the scope</li>
                                <li>Share – Send your design to friends</li>
                                <li>Download – Save the file for uploading to your device</li>
                            </ul>
                        </div>
                    </>
                )}

            </div>

        </>
    )
}

export default QuestionContent;
